import { cn } from '../lib/cn';

export type StatAccent = 'yellow' | 'green' | 'orange' | 'blue' | 'neutral';

const ACCENT: Record<StatAccent, string> = {
  yellow: 'border-l-yhelp-yellow',
  green: 'border-l-status-resolvido',
  orange: 'border-l-sla-warning',
  blue: 'border-l-status-aberto',
  neutral: 'border-l-neutral-400',
};

export interface StatCardProps {
  label: string;
  value: string | number;
  trend?: string;
  accent?: StatAccent;
  className?: string;
}

export function StatCard({ label, value, trend, accent = 'neutral', className }: StatCardProps) {
  return (
    <div
      className={cn(
        'surface-card border-l-4 p-6 animate-fade-in-up motion-reduce:animate-none',
        ACCENT[accent],
        className,
      )}
    >
      <p className="text-sm text-neutral-500 dark:text-neutral-400">{label}</p>
      <p className="mt-2 text-3xl font-extrabold text-yhelp-black dark:text-white">{value}</p>
      {trend ? (
        <p className="mt-1 text-xs text-neutral-500 dark:text-neutral-400">{trend}</p>
      ) : null}
    </div>
  );
}
